export const APP_VERSION:string = '2.9.6';
